import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()


export const actions = {
  getHonor: action({
    type: 'aboutUs.getHonor',
    action: (http) => {
      return http.get(`/cms-web-api/config?name=ztx_pc_honor`)
    },
    handler: (state, result) => {
      return {
        honors: result.data
      }
    }
  }, reducerHandler),
  getAnnouncementList: action({
    type: 'aboutUs.getAnnouncementList',
    action: (page, http) => {
      return http.get(`/cms-web-api/cms/content/list/ztx/announcement?page=${page}`)
    },
    handler: (state, result) => {
      return {
        ...state,
        announcementList: result.data.items,
        announcementPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      }
    }
  }, reducerHandler),
  getAnnouncementDetail: action({
    type: 'aboutUs.getAnnouncementDetail',
    action: (id, http) => {
      return http.get('/cms-web-api/cms/content/show/ztx/' + id)
    },
    handler: (state, result) => {
      return {
        ...state,
        announcement: result.data
      }
    }
  }, reducerHandler),
  getNewsList: action({
    type: 'aboutUs.getNewsList',
    action: (page, http) => {
      return http.get(`/cms-web-api/cms/content/list/ztx/news?page=${page}&order=created_at`)
    },
    handler: (state, result) => {
      return {
        ...state,
        newsList: result.data.items,
        newsPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      }
    }
  }, reducerHandler),
  
  getLoanInfoList: action({
    type: 'aboutUs.getLoanInfoList',
    action: (page, http) => {
      return http.get(`/cms-web-api/cms/content/list/ztx/loanInfo?page=${page}&order=created_at`)
    },
    handler: (state, result) => {
      return {
        ...state,
        loanInfoList: result.data.items,
        loanInfoPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      }
    }
  }, reducerHandler),
  getNewsDetail: action({
    type: 'aboutUs.getNewsDetail',
    action: (id, http) => {
      return http.get('/cms-web-api/cms/content/show/ztx/' + id)
    },
    handler: (state, result) => {
      return {
        ...state,
        news: result.data
      }
    }
  }, reducerHandler),
  getProvinceList: action({
    type: 'aboutUs.getProvinceList',
    action: (http) => {
      return http.get('/cms-web-api/area/bypid?pid=0')
    },
    handler: (state, result) => {
      return {
        ...state,
        provinceList: result.data
      }
    }
  }, reducerHandler),
  getCityList: action({
    type: 'aboutUs.getCityList',
    action: (pid, http) => {
      return http.get(`/cms-web-api/area/bypid?pid=${pid}`)
    },
    handler: (state, result) => {
      return {
        ...state,
        cityList: result.data
      }
    }
  }, reducerHandler),
  getShopList: action({
    type: 'aboutUs.getShopList',
    action: (code, page, http) => {
      return http.get(`/cms-web-api/mendian?code=${code}&page=${page}`)
    },
    handler: (state, result) => {
      return {
        ...state,
        shopList: result.data.items,
        shopPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      }
    }
  }, reducerHandler)
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

}

const initialState = {
  newsList: []
}

export function reducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  let nextState =  handler ? handler(state, action) : {...state}
  nextState = reducerHandler(initialState)(nextState, action)
  return nextState
}



// WEBPACK FOOTER //
// ./modules/aboutUs/redux.js